import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import dashboardStyle from "assets/jss/material-dashboard-pro-react/layouts/dashboardStyle";
import connection from "../../connection";
import BaseDashboard from "./BaseDashboard";

class Painel extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      dashboard: null,
      acoes: null
    }
  }

  componentDidMount() {
    this.loadAllData();
  }

  loadAllData = async () => {
    let data = await connection.get("dashboard/obter");

    this.setState({
      dashboard: data,
      acoes: data.acoes
    });
  };

  reloadAcoes = async (fullReload) => {
    if (fullReload)
      await this.loadAllData();
    else
      this.setState({
        acoes: await connection.get("dashboard/tarefas_pendentes")
      })
  };

  render() {
    return (<div>
      {this.state.dashboard && <BaseDashboard data={this.state.dashboard} acoes={this.state.acoes} reloadAcoes={this.reloadAcoes}/>}
    </div>);
  }
}

export default withStyles(dashboardStyle)(Painel);
